module.exports = __webpack_public_path__ + "static/media/MIISimg.49fddf4d.png";